
// This mixin highlights matched text in a text input filter.
// When using the general filter, it higlights all fields using this method.
// The method expects a string (field) as the first argument,
// and the name of the filter to use (filter) as the second argument.
export default {
  methods: {
    highlight(field, filter) {
      // Make sure null field does not throw error.
      field = field || '';

      const input = this.searchTerm === '' ? filter : this.searchTerm;

      // Only begin higlighting when user has entered 2 or more characters.
      if (input && input.length < 2) {
        return field;
      }

      // Build regex to match query string.
      const regex = new RegExp(input, 'gi');

      // Match and replace query string with highlighted text.
      return field
        .replace(regex, matchedTxt => (`<span class='highlight'>${matchedTxt}</span>`));
    },
  },
};
